
import { computed, onMounted, ref, useContext } from '@nuxtjs/composition-api';
import { requiredFields } from '~/composable/validation/utils';
import {
  INITIATE_NP,
  CHECKOUT_FLOW,
  SECRET_NUMBER_TYPE,
  CUSTOMER_SUBSCRIPTION_TYPE
} from '~/constants/CheckoutFlow';
import useNumberPorting from '@/composable/useNumberPorting';
import useFlow from '@/composable/checkout/config/useFlow';
import useCheckout from '@/composable/checkout/useCheckout';
import { FLOW_STEP_STATUS } from '~/constants/FlowStepStatus';
import useTlmCart from '@/composable/useTlmCart';
import useCartQueries from '~/composable/useCartQueries';

export default {
  name: 'TlmCheckoutSubscriptionMoveNumber',
  setup () {
    const { app } = useContext()
    const { state, checkoutType } = useCheckout(app)
    const { subscription } = state;
    const { moveNumber, menu } = subscription;
    const formValid = ref(false)
    const { getItemAttributesForSubscriptionFromCart, cart, isEsimOnlyDevice } = useTlmCart(app)
    const { getCurrentStepStatus } = useFlow(app, state)
    const { validateMobileNumber, teleOperatorInfo, validateIcc, iccErrors, iccMessages, iccLoading, ochErrors, ochValid, ochMessages, ochLoading } = useNumberPorting(app)
    const { cartOnlyContainsSubscription } = useCartQueries(app, cart)
    const resetSim = () => {
      moveNumber.simcardNumber = ''
    }

    const validateNumber = async (v) => {
      if (v.length === 8) {
        await validateMobileNumber(v)
        moveNumber.numberValid = ochValid.value
        moveNumber.cpsCode = teleOperatorInfo.value.cps
      } else {
        moveNumber.numberValid = false
      }
    }
    const validateIccForNP = async (v) => {
      if (teleOperatorInfo?.value?.cps && v) {
        await validateIcc(teleOperatorInfo.value.cps, v)
      }
    }
    const isSecretNumberValid = computed(() => {
      return moveNumber.secretNumber.selected ? moveNumber.secretNumber.radioGroup !== 'SecretNone' : true
    })
    // eslint-disable-next-line complexity
    moveNumber.valid = computed(() => {
      const simValid = moveNumber.registerSimLater || requiredFields(['simcardNumber'], moveNumber)
      return moveNumber.accepted && moveNumber.numberValid && simValid && isSecretNumberValid.value &&
        (isEsimOnlyDevice.value ? moveNumber.simTypeRadioGroup && moveNumber.currentSimType : moveNumber.simTypeRadioGroup);
    });

    const formSubmitted = () => {
      $nuxt.$emit('formSubmitted')
    }
    const simType = computed(() => {
      return getCurrentStepStatus.value === FLOW_STEP_STATUS.EDITING
        ? getItemAttributesForSubscriptionFromCart('SIMCardType')
        : moveNumber.simTypeRadioGroup
    })
    const secretInfoChosen = computed(() => {
      if (getCurrentStepStatus.value === FLOW_STEP_STATUS.EDITING) {
        return {
          selected: getItemAttributesForSubscriptionFromCart('SecretInfoType') !== SECRET_NUMBER_TYPE.SECRET_NONE,
          radioGroup: getItemAttributesForSubscriptionFromCart('SecretInfoType')
        }
      } else {
        return {
          selected: moveNumber.secretNumber.selected,
          radioGroup: moveNumber.secretNumber.radioGroup
        }
      }
    })
    onMounted(() => {
      $nuxt.$on('editModeForSubscription', () => {
        if (getCurrentStepStatus.value === FLOW_STEP_STATUS.EDITING) {
          validateNumber(moveNumber.mobileNumber)
        }
      })
    })
    const isNumberPorting = computed(() => {
      return menu.value === CUSTOMER_SUBSCRIPTION_TYPE.MOVE_NUMBER
    })
    return {
      isNumberPorting,
      SECRET_NUMBER_TYPE,
      simType,
      secretInfoChosen,
      checkoutType,
      CHECKOUT_FLOW,
      FLOW_STEP_STATUS,
      getCurrentStepStatus,
      isSubscriptionOnly: cartOnlyContainsSubscription,
      checkboxRules: [
        (v) => !!v || 'Du skal acceptere at Telmore må flytte dit nummer.'
      ],
      ochErrors,
      ochMessages,
      ochLoading,
      formSubmitted,
      iccLoading,
      iccMessages,
      iccErrors,
      validateNumber,
      INITIATE_NP,
      resetSim,
      formValid,
      moveNumber,
      validateIccForNP,
      isEsimOnlyDevice
    };
  }
};
